import { withInstall } from '@sgui-plus/utils/with-install'
import Popper from './src/popper.vue'

export { default as SgPopperArrow } from './src/arrow.vue'
export { default as SgPopperTrigger } from './src/trigger.vue'
export { default as SgPopperContent } from './src/content.vue'

export const SgPopper = withInstall(Popper)
export default SgPopper

export * from './src/popper'
export * from './src/tokens'

export type { Placement, Options } from '@popperjs/core'
